import Vue from 'vue';
import App from './App.vue';
import router from './router';
import BootstrapVue from 'bootstrap-vue';

import { PnetLoadingPlugin } from '@previnet/vue-loading';
import { PnetObservableFormPlugin } from '@previnet/vue-validation';
import { PnetVueDatatablePlugin } from '@previnet/vue-datatable';

import config from "@/services/config";
import store from '@/store';

import './assets/main.scss';
import ('./assets/main_' + config.codCliente + '.scss');
//import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(PnetLoadingPlugin);
Vue.use(PnetObservableFormPlugin);
Vue.use(PnetVueDatatablePlugin);
//Vue.use(require('vue-moment'));

new Vue({
  router,
  store,
  render: (h): any => h(App),
}).$mount('#app');
